import { ThemeProjectSpace4Leads } from 'config/theme/project/white-labels/ThemeProjectSpace4Leads'

export const ThemeProject = ThemeProjectSpace4Leads
